<template>
    <div class="modal fade is-scroll" :class="{ in: isShowModal, active: isShow, }"
        tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" v-show="isShow">
        <div class="modal-bg" @click="onModalClose"></div>
        <div class="modal-dialog">
            <div class="modal-content" :class="{ 'QIAOHU_ROOM_DETAIL_CSS': stateroomDetail.isQiaohu || stateroomDetail.groupType === 'QIAOHU'}">
                <div class="common-modal-close" data-dismiss="modal" aria-label="Close" @click="onModalClose">
                    <img class="common-modal-close" src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/modal-close.jpg">
                </div>

                <div class="modal-body">
                    <div class="inner">
                        <div class="inner-left">
                            <div class="left_box">
                                <BannerDetail v-if="stateroomImages.length > 0"
                                    :banners="stateroomImages"
                                />
                            </div>
                        </div>
                        <div class="inner-right">
                            <div class="room_detail">
                                <div class="room_title">
                                    {{getStateroomName}}
                                </div>
                                <div class="room_info">
                                  <span>舱房：{{stateroomDetail.stateroomArea}}</span>
                                  <span>阳台：{{stateroomBalconyArea}}</span>
                                  <span v-if="stateroomDetail.stateroomFloor&&stateroomDetail.stateroomFloor.length>0">楼层：{{stateroomDetail.stateroomFloor}}</span>
                                </div>
                                <DeviceFeatureTags v-if="stateroomDetail.deviceFeatureTags"
                                                    :viewNum="stateroomDetail.deviceFeatureTags.length"
                                                    :tags="stateroomDetail.deviceFeatureTags"></DeviceFeatureTags>
                                <div @click="showQiaohuPopup" v-if="stateroomDetail.isQiaohu || stateroomDetail.groupType === 'QIAOHU'">
                                    <img class="qiaohu_tag" src="https://resource.rcclchina.com.cn/QIAOHU/qiaohu.png">
                                </div>
                                <div class="room_price">
                                    <span v-if="stateroomDetail.stateroomPrice>0&&isShowPrice">
                                        <span class="title">{{stateroomDetail.stateroomPriceType}}（含税）</span>
                                        <em class="price">￥<em class="number">{{stateroomDetail.stateroomPrice.toFixed(0)}}</em>/人起</em>
                                    </span>

                                    <NrpTag
                                        :isNrp="stateroomDetail.isNrp"
                                        :isFortyEightHoursNrpCruise="isFortyEightHoursNrpCruise"
                                        :direction="nrpTagDirection"
                                        :customClasses="nrpTagClasses"
                                    />
                                </div>

                                <div class="qiaohu_content" v-if="stateroomDetail.isQiaohu || stateroomDetail.groupType === 'QIAOHU'">
                                  <div class="qiaohu_title_css">
                                    主题房内到处可以找到巧虎的可爱身影，床罩、沙发靠垫、壁画，阳台门以及墙上都有巧虎元素的装饰。
                                  </div>
                                  <div class="qiaohu_title_css">
                                    <div class="title_css">预订巧虎主题房可享福利：</div>
                                    <div>
                                      1. 巧虎神秘萌礼<br>
                                      2. 和巧虎一起早餐
                                    </div>
                                  </div>
                                  <div class="qiaohu_title_css">
                                    <div class="title_css">航程中可以与巧虎一起参加哪些活动？</div>

                                    <div>
                                      1. 巧虎欢迎仪式<br>
                                      2. 与巧虎小船长互动拍照留念<br>
                                      3. 在海上历奇中心和巧虎一起玩耍<br>
                                    </div>

                                  </div>

<!--                                    <div class="qiaohu_title_css">-->
<!--                                        <div class="title_css">巧虎主题房预订须知：</div>-->
<!--                                        <div>-->
<!--                                            巧虎主题房不可与同期其他促销活动及优惠券同享，包括但不限于品牌特惠及限时闪惠活动、招商银行折扣券、抽奖券等优惠促销活动，不可与皇家指定渠道专属优惠同享。-->
<!--                                        </div>-->
<!--                                    </div>-->
                                </div>

                                <div class="room_detail">
                                    <div class="title_css">舱房详情：</div>
                                    <div v-html="stateroomDetail.stateroomDescription"></div>
                                </div>
                                <div class="room_tips">
                                    注：房间图片仅供参考，以实际入住为准。
                                </div>
                                <div v-if="ruleDescription" class="" v-html="ruleDescription"></div>
                            </div>
                        </div>
                    </div>
                    <div v-if="stateroomDetail.deviceGroupTags && stateroomDetail.deviceGroupTags.length"
                         class="detail-main-module">
                      <div class="detail-module no-bc" style="padding-top: 0">
                        <div class="title-main">
                          <h3 class="title">舱房设施和体验</h3>
                          <div v-if="isFacilities" class="feature"><span>●</span>该设施为本房型特色设施</div>
                        </div>
                        <div class="content">
                          <DeviceGroupTags v-for="(item,index) in stateroomDetail.deviceGroupTags" :key="index"
                                           :category="item.name"
                                           :facilities="item.deviceTags"></DeviceGroupTags>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import bookingHelper from '@/utilities/bookingHelper'
const BannerDetail = () => import('@/components/BannerDetail.vue')
const NrpTag = () => import('@/components/Booking/NrpTag.vue')
const DeviceFeatureTags = ()=> import("@/components/Cruise/CruiseDetail/DeviceFeatureTags.vue");
const DeviceGroupTags = () => import('@/components/Cruise/CruiseDetail/DeviceGroupTags.vue')
export default {
    name: "StateroomDetail",
    components: {
        BannerDetail,
        NrpTag,
        DeviceFeatureTags,
        DeviceGroupTags
    },
    props: {
        isShow: {
            type: Boolean,
            default () {
                return false
            }
        },
        stateroomDetail: {
            type: Object,
            default () {
                return {
                    stateroomImages: [],
                    stateroomName: '',
                    stateroomCategory: '',
                    stateroomPriceType: '',
                    stateroomPrice: 0,
                    stateroomCapacity: '',
                    stateroomArea: '',
                    stateroomBalcony: '',
                    stateroomFloor: '',
                    isQiaohu: false,
                    isNrp: false,
                    stateroomDescription: '',
                    stateroomNrpTitle: '',
                    stateroomNrpText: '',
                    suiteMobileImageUrl: '',
                    stateroomShelter: '',
                    guestNumber: 0
                }
            }
        },
        isFortyEightHoursNrpCruise: {
            type: Boolean
        },
        showQiaohuPopup: {
            type: Function
        },
        isShowPrice: {
            type: Boolean,
            default () {
                return false
            }
        },
        ruleDescription: {
            type: String
        }
    },
    data () {
        return {
            isShowModal: false,
            imgUrl: process.env.VUE_APP_IMG_URL
        }
    },
    methods: {
        stateroomImageChange(slide) {
            if (slide == 'prev') {
                this.bannerSwiper.slidePrev()
            } else {
                this.bannerSwiper.slideNext()
            }
        },
        onModalClose () {
            this.isShowModal = false
            setTimeout(()=> {
                this.$emit('onModalClose')
            }, 100)
        }
    },
    computed: {
        stateroomBalconyArea () {
            const stateroom = this.stateroomDetail
            if (!stateroom.stateroomBalcony || stateroom.stateroomBalcony == '' || stateroom.stateroomBalcony == '无') {
                return '无阳台'
            }
            if (stateroom.stateroomShelter && stateroom.stateroomShelter.length > 0) {
                return "(" + stateroom.stateroomShelter + "视线遮挡) " + stateroom.stateroomBalcony
            }
            return stateroom.stateroomBalcony
        },
        getStateroomName() {
            const stateroom = this.stateroomDetail
            let name = stateroom.stateroomName + ''
            const shelter = stateroom.stateroomShelter
            if (shelter && shelter.length > 0 && name && name.indexOf('遮挡') < 0) {
                name += "（有遮挡）"
            }
            let code = stateroom.stateroomCategory
            if (code && code.indexOf('_') >= 0) {
                code = code.split('_')[0]
            }
            name = `${name}_${code}`
            if (stateroom.guestNumber && stateroom.guestNumber > 0) {
                let guestCountText = bookingHelper.getStateroomGuestNumber(stateroom.guestNumber)
                if (guestCountText.length > 0) {
                    name += `(${guestCountText})`
                }
            }
            return name
        },
        stateroomImages() {
            let images = []
            if (this.stateroomDetail && this.stateroomDetail.stateroomImages) {
                this.stateroomDetail.stateroomImages.forEach(image => {
                    images.push({
                        image
                    })
                })
            }
            return images
        },
        nrpTagClasses () {
            let nrpTagClasses = ['stateroomDetailNrp']
            if (this.isFortyEightHoursNrpCruise) {
                nrpTagClasses.push('fortyEightHoursNrp')
            }
            return nrpTagClasses
        },
        nrpTagDirection () {
            if (this.isFortyEightHoursNrpCruise) {
                return 'bottom'
            }
            return 'right'
        },
        isFacilities() {
          let isFeature = false;
          for(let i = 0; i < this.stateroomDetail.deviceGroupTags.length; i++) {
            let deviceGroupTags = this.stateroomDetail.deviceGroupTags[i];
            for(let j = 0; j < deviceGroupTags.deviceTags.length; j++) {
              let deviceTags = deviceGroupTags.deviceTags[j];
              if(deviceTags.isFeature) {
                isFeature = true;
                break;
              }
            }
            if(isFeature) break;
          }
          return isFeature;
        }
    },
    watch: {
      stateroomDetail() {},
      isShow (newValue) {
          setTimeout(()=> {
              this.isShowModal = newValue
          }, 100)
      }
    }
}
</script>

<style lang="less" scoped>

.modal-dialog {
    top: 50px;
    width: 1000px;

}
.modal.active {
    display: block;
}
.modal.is-scroll {
  overflow-x: hidden;
  overflow-y: auto;
}
.modal-content {
  background-color: #FAFAFA;
  border-radius: 12px;
}
.modal-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
}

.modal-body {
    position: relative;
    padding: 0;
    border-radius: 15px;
    //background-color: #FFFFFF;
    background-color: #FAFAFA;
    .inner {
      overflow: hidden;
      padding: 25px 25px;
      & .inner-left{
        float: left;
        margin-right: 30px;
        height: 320px;
        width: 450px;
      }
      & .inner-right{
        overflow: hidden;
      }
    }
    .room_detail {
        margin-top: -1px;
        .room_title {
            font-size: 22px;
            color: #282b2c;
            margin-bottom: 10px;
            font-weight: bold;
            padding-right: 40px;
        }
        .qiaohu_tag {
            cursor: pointer;
            margin-top: 10px;
        }
        .room_price {
            color: #282b2c;
            margin-top: 20px;
            padding-right: 40px;
            .title {
              font-weight: bold;
            }
            .price {
                color: #ff3022;
                font-weight: bold;
                font-style: normal;
                margin-right: 20px;
                & .number {
                  font-size: 24px;
                  font-style: normal;
                }
            }
            a {
                text-decoration: underline;
            }
        }
        .qiaohu_content {
            border-top: 1px solid #ccc;
            border-bottom: 1px solid #cccc;
            padding-top: 10px;
            margin-bottom: 10px;
            .qiaohu_title_css {
                margin-bottom: 10px;
            }
        }
        .title_css {
            font-weight: 600;
            margin-bottom: 1px;
            margin-top: 25px;
            font-size: 20px;
            color: #282b2c;
        }
        .room_info {
            margin-bottom: 10px;
            padding-right: 40px;
            span {
                position: relative;
                display: inline-block;
                margin-right: 28px;
                color: #a6aeb1;
            }
            span::after {
                content: '';
                position: absolute;
                width: 2px;
                height: 12px;
                display: block;
                background: #cacaca;
                top: 4px;
                right: -14px;
            }
            span:last-child:after {
                display: none;
            }
        }
        .room_detail {
            margin-top: -1px;
            line-height: 1.6;
            margin-bottom: 10px;
        }
    }
}

.ship_tags {
  margin-top: 8px;
  & .tag {
    display: inline-block;
    margin-right: 25px;

    & > img {
      display: inline-block;
      height: 14px;
      margin-right: 5px;
    }
    & > div {
      line-height: 14px;
      font-size: 13px;
      color: #282b2c;
      display: inline-block;
    }
  }
}

.detail-main-module {
  padding-top: 35px;
  padding-bottom: 10px;
  border-radius: 40px 40px 15px 15px;
  box-shadow: 0 0 10px rgba(0,0,0,.2);
  background-color: #FFFFFF;
  & .detail-main-module-inner {
    padding-bottom: 20px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  & .detail-module {
    padding: 35px 0 25px;
    margin: 0 25px;
    border-bottom: 1px solid #BCC2C4;
    &.no-bc {
      border: none;
    }
    & > .title-main {
      position: relative;
      & > .title {
        position: relative;
        padding: 0 0 0 13px;
        margin: 0;
        font-size: 22px;
        font-weight: bold;
        color: #333333;
        &:before {
          content: "";
          display: block;
          width: 5px;
          height: 20px;
          position: absolute;
          top: 2px;
          left: 0;
          background-color: #0074BA;
        }
      }
      & > .feature {
        position: absolute;
        top: 4px;
        right: 0;
        font-size: 12px;
        color: #a6aeb1;
        & > span {
          position: absolute;
          left: -15px;
          top: -1px;
          font-size: 12px;
          margin-left: 4px;
          color: #0173BC;
        }
      }
    }
    & .content {
      padding: 20px 0 0 0;
    }
    & .room-devices {
      overflow: hidden;
      & > li {
        width: 32.33%;
        margin-right: 1%;
        float: left;
        & .title {
          font-size: 16px;
          font-weight: bold;
          margin: 10px 0 15px;
          color: #333333;
        }
      }
    }
  }
}

.QIAOHU_ROOM_DETAIL_CSS {
    background: #fff url(https://resource.rcclchina.com.cn/QIAOHU/PC/QIAOHU_Icon_Detail.png) no-repeat left bottom;
    border: 3px solid #ffe100;
}

</style>
